import { render, staticRenderFns } from "./OrderCompleteItem.vue?vue&type=template&id=315c61cf&scoped=true&"
import script from "./OrderCompleteItem.vue?vue&type=script&lang=js&"
export * from "./OrderCompleteItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderCompleteItem.vue?vue&type=style&index=0&id=315c61cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c61cf",
  null
  
)

export default component.exports